import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Translate, withLocalize } from 'react-localize-redux';
import AddMonitorBar from './AddMonitorBar';
import { ASK_SUGGESTION_KEYS, TRANSLATION_KEY } from '../constants';
import css from './WatchlistEmptyState.css';

const WatchlistEmptyState = ({
    onSubmit,
    scheduleCron,
    onScheduleClick,
    submitting = false,
    error = null,
    translate,
}) => {
    const [suggestion, setSuggestion] = useState('');

    return (
        <div className={css.emptyState}>
            <div className={css.title}>
                <Translate id={`${TRANSLATION_KEY}.EMPTY_STATE.TITLE`} />
            </div>
            <div className={css.subtitle}>
                <Translate id={`${TRANSLATION_KEY}.EMPTY_STATE.SUBTITLE`} />
            </div>
            <AddMonitorBar
                key={suggestion}
                initialValue={suggestion}
                onSubmit={onSubmit}
                scheduleCron={scheduleCron}
                onScheduleClick={onScheduleClick}
                submitting={submitting}
                error={error}
                isEmptyVariant
            />
            <div className={css.suggestionsTitle}>
                <Translate id={`${TRANSLATION_KEY}.EMPTY_STATE.SUGGESTIONS_TITLE`} />
            </div>
            <div className={css.suggestions}>
                {ASK_SUGGESTION_KEYS.map(suggestionKey => (
                    <button
                        key={suggestionKey}
                        type="button"
                        className={css.suggestion}
                        onClick={() => setSuggestion(translate(suggestionKey))}
                    >
                        <Translate id={suggestionKey} />
                    </button>
                ))}
            </div>
        </div>
    );
};

WatchlistEmptyState.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    scheduleCron: PropTypes.string.isRequired,
    onScheduleClick: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    error: PropTypes.string,
    translate: PropTypes.func.isRequired,
};

export default withLocalize(WatchlistEmptyState);
